import { apiClient } from './api'

/** Roles a super admin can grant. Mirrors `ASSIGNABLE_ROLES` in automotive-api. */
export const ASSIGNABLE_ROLES = ['SUPER_ADMIN', 'STAFF'] as const
export type AssignableRole = (typeof ASSIGNABLE_ROLES)[number]

export const ROLE_LABELS: Record<string, string> = {
  SUPER_ADMIN: 'Super admin',
  STAFF: 'Staff',
}

export const ROLE_DESCRIPTIONS: Record<AssignableRole, string> = {
  SUPER_ADMIN: 'Everything, including system administration and dealer configuration',
  STAFF: 'Sees every dealership: dashboards, appointments and conversations',
}

export interface DashboardUser {
  id: string
  email: string
  name?: string
  role: string
  isActive: boolean
  hasSignedIn: boolean
  createdAt: string
  updatedAt: string
}

export interface DashboardUserList {
  users: DashboardUser[]
  total: number
  page: number
  perPage: number
}

export interface ListDashboardUsersParams {
  search?: string
  role?: string
  status?: 'active' | 'disabled'
  page?: number
  perPage?: number
}

export const dashboardUsersApi = {
  list(params: ListDashboardUsersParams): Promise<DashboardUserList> {
    return apiClient.get<DashboardUserList>('/admin/users', params)
  },

  create(body: { email: string; name: string; role: AssignableRole }): Promise<DashboardUser> {
    return apiClient.post<DashboardUser>('/admin/users', body)
  },

  update(userId: string, body: { role?: AssignableRole; isActive?: boolean }): Promise<DashboardUser> {
    return apiClient.patch<DashboardUser>(`/admin/users/${encodeURIComponent(userId)}`, body)
  },
}
